import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingDimension  {
    _originalTypeClassName = "zERP.BO.AccountingDimension";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingDimension.translate = translateService;
}
this.Values = [];
this.Id = null;
this.Name = null;
this.Color = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Color:any;
Values:any;
static setValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.Values == null) $this.Values = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Values.length > 0) {
                    Domain.AccountingDimension.removeValues($this, $this.Values[0]);
                }

                Domain.AccountingDimension.addManyValues($this, copyItems);
            }
static addManyValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingDimension.addValues($this, items[i]);
                }
            }
static addValues = ($this, item) => {
                if ($this.Values == null) $this.Values = [];
                if (item == null || $this.Values.indexOf(item) > -1) return;
                $this.Values.push(item);
if (item.Dimension != $this) {
Domain.AccountingDimensionValue.setDimension(item, $this);
}
}
static addRangeValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingDimension.addValues($this, item));
            }
static removeValues = ($this, item) => {
                if ($this == null || $this.Values == null || $this.Values.indexOf(item) === -1) return;
                var _index = $this.Values.indexOf(item);
                $this.Values.splice(_index, 1);
item.Dimension = null;
}
static clearValues = ($this) => { $this.Values = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}